import { Compass, Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";

export const Header = ({ onReset }) => {
  const { theme, toggle } = useTheme();
  return (
    <header className="sticky top-0 z-30 border-b border-border/70 bg-background/75 backdrop-blur-xl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-brand-logo"
          onClick={onReset}
          className="flex items-center gap-3 group"
        >
          <span className="grid place-items-center h-9 w-9 rounded-full border border-primary/60 bg-card text-primary transition-transform duration-500 group-hover:rotate-[30deg]">
            <Compass className="h-5 w-5" strokeWidth={1.6} />
          </span>
          <span className="text-left leading-none">
            <span className="font-display font-medium text-xl tracking-tight block">
              Atlas<span className="italic text-primary">-GPS</span>
            </span>
            <span className="eyebrow text-muted-foreground">Route-first learning</span>
          </span>
        </button>

        <div className="flex items-center gap-4">
          <span className="hidden sm:inline eyebrow text-muted-foreground">
            Beta · MMXXVI
          </span>
          <button
            data-testid="theme-toggle-button"
            onClick={toggle}
            aria-label="Toggle theme"
            className="grid place-items-center h-9 w-9 rounded-full border border-border bg-card/60 hover:border-primary/60 hover:text-primary transition-colors"
          >
            {theme === "dark" ? (
              <Sun className="h-4 w-4" strokeWidth={1.7} />
            ) : (
              <Moon className="h-4 w-4" strokeWidth={1.7} />
            )}
          </button>
        </div>
      </div>
    </header>
  );
};
